var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResponseRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-star",
    d: "M12,0A12,12,0,1,0,24,12,12.01,12.01,0,0,0,12,0Zm5.17,11.62L15,13.39l.9,2.73a.908.908,0,0,1-.31,1.01.917.917,0,0,1-1.06.04l-2.52-1.64L9.53,17.19a.936.936,0,0,1-1.06-.03.912.912,0,0,1-.32-1.01l.86-2.76L6.83,11.62a.912.912,0,0,1,.59-1.61h2.75l.97-2.61a.916.916,0,0,1,1.72,0l.97,2.61h2.75a.918.918,0,0,1,.86.6.936.936,0,0,1-.27,1.02Z",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponseRate);
export default __webpack_public_path__ + "static/media/response-rate.1c5e03e556b159158b867ba21235fccb.svg";
export { ForwardRef as ReactComponent };